module.exports = __webpack_public_path__ + "static/media/article_default_image.073eecbe.png";